<!-- 横向商品列表-固定3个 -->
<template>
  <div class="special-offer-container special-offer-box" :style="{marginBottom: (data.marginBottom ) / 16 + 'rem'}">
    <h2>{{data.title}}<span class="subtitle">{{data.subTitle}}</span></h2>
    <ul class="list">
      <li class="list-item" v-for="(item, index) in list" :key="index" @click="click(item,index)">
        <div>
          <img :src="item.icon" alt="" loading="lazy">
          <div class="middle">
            <p class="item-title">{{item.firstClass}}</p>
            <p class="current-price"><span class="icon">¥</span>{{item.price}}</p>
            <p class="origin-price">¥{{item.originPrice}}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import clientUtil from '../common/clientUtil';
  import { post } from '../common/http';
  import { goodsListSort, sensorsBuriedPoint } from '../common/util';
  export default {
    props: {
      data: {
        type: Object,
        default: () => { return {} }
      }
    },
    data() {
      return {
        vipEntrance: this.$route.query.from,
        list: [
          {
            icon: 'https://www.haohuan.com/datahub/file/2021-01/09cbd7191017ec0d03ab54eac91b3e39.png',
            name: '爱奇艺月卡',
            price: '29.9',
            originPrice: '49.9',
          },
          {
            icon: 'https://www.haohuan.com/datahub/file/2021-01/09cbd7191017ec0d03ab54eac91b3e39.png',
            name: '网易云音乐黑胶会员',
            price: '29.9',
            originPrice: '49.9',
          },
          {
            icon: 'https://www.haohuan.com/datahub/file/2021-01/09cbd7191017ec0d03ab54eac91b3e39.png',
            name: '爱奇艺月卡',
            price: '29.9',
            originPrice: '49.9',
          }
        ],
      }
    },
    created() {
      this.loadData();
    },
    methods: {
      loadData() {
        if (this.data.idList.indexOf("0") != -1) {
          return;
        }
        const data = {
          productCode: this.data.idList
        };
        post('/api/saveMoneyCard/right/cheapest', data).then(res => {
          this.list = goodsListSort(data.productCode, res.data)
        })
      },
      click(item, index) {
        const sensorObj = {
          LocationPage: `${this.$route.query.code}${document.title}`,
          EntryName: this.data.title,
          EntryRank: index + 1,
          RightName: item.productCode
        };
        sensorsBuriedPoint('MarketingPageClick', sensorObj)
        clientUtil.openNewWebPage({
          pageUrl: `flutter://economicalCard/rightsDetail?callback_origin=${this.vipEntrance}&firstClass=${item.firstClass}&equityType=1&product_code=${item.productCode}`,
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .special-offer-box {
    h2 {
      padding-top: 16px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 8px;
      padding-left: 12px;

      span {
        margin-left: 8px;
        font-size: 13px;
        line-height: 19px;
      }
    }

    .current-price {
      margin-bottom: 2px;
      font-size: 17px;
      font-family: DINPro-Medium, DINPro;
      color: #ff3838;
      line-height: 23px;

      .icon {
        margin-right: 2px;
        font-size: 13px;
        font-weight: bold;
        color: #ff3838;
        font-family: DINAlternate-Bold, DINAlternate;
        line-height: 18px;
      }

      .text {
        margin-left: 1px;
        font-size: 11px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #ff3838;
        line-height: 18px;
      }
    }
  }
  .special-offer-container {
    margin: 0 auto 12px;
    height: 198px;
    width: 351px;
    background-image: url("https://www.haohuan.com/datahub/file/2021-03/5fcc92aa44ad5c93bab972b3d38d809b.png");
    background-size: 100% 100%;
    background-position: center;
    border-radius: 8px;

    h2 {
      color: #ffffff;

      .subtitle {
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .list {
      display: flex;
      justify-content: space-between;
      padding: 0 12px;

      &-item {
        width: 104px;
        height: 138px;
        margin-right: 8px;
        background: #ffffff;
        border-radius: 4px;
        text-align: center;

        img {
          margin: 18px auto 14px;
          width: 38px;
          height: 38px;
          border-radius: 50%;
          display: block;
        }

        .item-title {
          margin-bottom: 8px;
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2e2e33;
          line-height: 12px;
        }

        .origin-price {
          font-size: 11px;
          font-family: DINPro-Medium, DINPro;
          font-weight: 500;
          color: #919199;
          line-height: 16px;
          text-decoration: line-through;
        }
      }
    }
  }
</style>
